import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./chatStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function Settings() {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const eventId = searchParams.get("eventId");
    const ownerId = searchParams.get("ownerId");
    const name = searchParams.get("name");
    const [isAdmin, setIsAdmin] = useState(false);

    const ownId = localStorage.getItem("id");

    const [message, setMessage] = useState("");
    const [chat, setChat] = useState([]);
    const [chatId, setChatId] = useState();

    const bottomRef = useRef(null);
    const firstRender = useRef(true);

    useEffect(() => {
        document.title = "DJ - EMAN"

        getChat();

        const role = localStorage.getItem("role");
        if (role === "admin") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        const intervalId = setInterval(() => {
            getChat();
        }, 1000);

        return () => {
            clearInterval(intervalId);
        }
    }, []);

    const getChat = async () => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/chat?token=" + Cookies.get("token") + "&eventId=" + eventId + "&ownerId=" + ownerId, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.ok) {
                const data = await response.json();
                setChat(data);
                setChatId(data[0].chatId);
                if (firstRender.current) {
                    setTimeout(() => {
                        bottomRef.current?.scrollIntoView({behavior: "auto"});
                        firstRender.current = false;
                    }, 200);
                }
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const sendMessage = async () => {
        try {
            const messageData = {
                chatId: chatId,
                eventId: eventId,
                writerId: ownId,
                message: message,
                isAdmin: isAdmin,
            }

            const response = await fetch("https://djeman.de:8443/api/v1/new-message?token=" + Cookies.get("token"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(messageData),
            });

            if (response.ok) {
                setMessage("");
                getChat();
                setTimeout(() => {
                    bottomRef.current?.scrollIntoView({behavior: "auto"});
                }, 200);
            } else {
                toast.error("Deine Nachricht konnte nicht gesendet werden");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function switchSide(side) {
        navigate(side);
    }

    return (
        <div className="chatContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>DJ Chat</h1>
            <img className="backArrow" onClick={() => switchSide("/musicrequestevent?id=" + eventId)}src="/img/arrowLeft.svg" />
            <div className="messagesContainer">
                {chat.map((message) => (
                    <div className={`messageContainer ${message.writerId == ownId ? "right" : "left"}`}>
                        <h1>{isAdmin ? message.writerId == ownId ? "Du:" : name + ":" : message.writerId == ownId ? "Du:" : "DJ:"}</h1>
                        <h2>{message.message}</h2>
                    </div>
                ))}
                <div ref={bottomRef} />
            </div>
            <div className="inputContainer">
                <input
                    type="message"
                    placeholder="Nachricht"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                />
                <img onClick={() => sendMessage()} src="/img/paper-plane.svg" />
            </div>
        </div>
    )
}
